import { render, staticRenderFns } from "./healthDetailPage1.vue?vue&type=template&id=4bbd616a&scoped=true"
import script from "./healthDetailPage1.vue?vue&type=script&lang=js"
export * from "./healthDetailPage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd616a",
  null
  
)

export default component.exports